import { AssociationSource } from "common/associations/association-browser.service";
import { assertDefined } from "core/functions";
import ProcessView = stages.process.ProcessView;
import ViewableEnactmentAssociationGroup = stages.process.ViewableEnactmentAssociationGroup;
import ProcessTreeItem = stages.process.ProcessTreeItem;
import ViewableProcess = stages.process.ViewableProcess;
import ViewableType = stages.process.ViewableType;

type EnactmentTargetElement = stages.common.AssociationTarget;

export class EnactmentAdapter implements AssociationSource<EnactmentTargetElement> {
	constructor(public element: ProcessView) {}

	get associations(): Record<string, ViewableEnactmentAssociationGroup> {
		return assertDefined(
			this.element.enactmentAssociations,
			"element is expected to have EnactmentElement associations",
		);
	}

	get parent(): ProcessTreeItem | undefined {
		return this.element.parent;
	}

	get process(): ViewableProcess {
		return this.element.process;
	}

	get type(): ViewableType {
		return this.element.type;
	}

	get id(): string {
		return this.element.id;
	}

	get identity(): string {
		return this.element.identity;
	}
}
